import { CurrencyExchange } from "@mui/icons-material";
import { AppRoutes } from "../../router/routes";

export const NavBars = ()  =>[
    {
        id: "1",
        title: "Default Currency",
        icon: <CurrencyExchange fontSize="small" />,
        path: AppRoutes.currencySettings
    }
]

export const CURRENCY_KEY = 'default_currency';

export const TABLE_COLUMN_PREFERENCES = {
    project_table_columns: 'project_table_columns',
    product_table_columns: 'product_table_columns',
    proposal_table_columns: 'proposal_table_columns',
};